export const showLoading = (showing = false) => {
  return {
    type : 'LOADING_SHOW',
    showing 
  }
};
